import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Layout from '../components/Layout';
import { Button } from '../components/ui/button';
import { Bell, CheckCheck, Loader2 } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const NotificationsPage = () => {
  const { token } = useAuth();
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchNotifs(); }, []);

  const fetchNotifs = async () => {
    try {
      const res = await axios.get(`${API}/notifications`, { headers: { Authorization: `Bearer ${token}` } });
      setNotifications(res.data.notifications || []);
    } catch {} finally { setLoading(false); }
  };

  const markAllRead = async () => {
    try {
      await axios.put(`${API}/notifications/read-all`, {}, { headers: { Authorization: `Bearer ${token}` } });
      await fetchNotifs();
    } catch {}
  };

  const unread = notifications.filter(n => !n.read).length;

  return (
    <Layout>
      <div className="max-w-3xl mx-auto" data-testid="notifications-page">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="font-heading text-3xl font-bold text-white">NOTIFICACIONES</h1>
            <p className="text-zinc-400 mt-1">{unread} sin leer</p>
          </div>
          {unread > 0 && (
            <Button onClick={markAllRead} variant="outline" size="sm" className="border-white/10 text-white">
              <CheckCheck className="w-4 h-4 mr-2" />Marcar todas leídas
            </Button>
          )}
        </div>

        {loading ? (
          <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 text-primary animate-spin" /></div>
        ) : notifications.length === 0 ? (
          <div className="bg-surface border border-white/10 rounded-md p-12 text-center">
            <Bell className="w-10 h-10 text-zinc-600 mx-auto mb-3" />
            <p className="text-zinc-400">No tienes notificaciones</p>
          </div>
        ) : (
          <div className="bg-surface border border-white/10 rounded-md divide-y divide-white/5">
            {notifications.map(n => (
              <div key={n.id} className={`p-4 ${!n.read ? 'bg-primary/5' : ''}`}>
                <div className="flex items-start gap-3">
                  <Bell className={`w-4 h-4 mt-0.5 flex-shrink-0 ${!n.read ? 'text-primary' : 'text-zinc-600'}`} />
                  <div className="flex-1">
                    {n.ticket_id ? (
                      <Link to={`/tickets/${n.ticket_id}`} className="text-white text-sm hover:text-primary">{n.message}</Link>
                    ) : (
                      <p className="text-white text-sm">{n.message}</p>
                    )}
                    <p className="text-zinc-600 text-xs mt-1">{new Date(n.created_at).toLocaleString('es-ES')}</p>
                  </div>
                  {!n.read && <div className="w-2 h-2 rounded-full bg-primary flex-shrink-0 mt-1.5" />}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
};

export default NotificationsPage;
